'use strict';

/**
 * Init/handle prescription filter element
 */
function handlePrescriptionFilter($this) {
    var isFilterPrescriptionActive = $('.toggle-switch', $this).prop('checked');
    let $spans = $this.find('.toggle-text');
    $spans.toggleClass('active');
    $spans.each(function () {
        $this.attr('aria-pressed', $this.hasClass('active'));
    });

    var $indicator = $this.parent().find('.background-indicator');
    if (isFilterPrescriptionActive) {
        $indicator.css('left', '47%');
    } else {
        $indicator.css('left', '0');
    }

    $('.color-attribute').each(function () {
        var isRx = $(this).attr('data-has-rx-frame') === 'true';
        if (isFilterPrescriptionActive) {
            if (isRx) {
                $(this).removeClass('d-none');
            } else {
                $(this).addClass('d-none');
            }
        } else {
            $(this).removeClass('d-none');
        }
    });

    if (isFilterPrescriptionActive) {
        var $currentSwatchSelection = $('#color-variations-wrapper').find('.swatch.selected');
        $currentSwatchSelection.attr('data-non-prescription-selected', true);

        var firstPrescriptionSwatch = $('#color-variations-wrapper').find('.swatch:visible').first();
        if (firstPrescriptionSwatch.length > 0) {
            if (firstPrescriptionSwatch.hasClass('selected')) {
                switchPrescriptionCTAs(isFilterPrescriptionActive);
            }
            firstPrescriptionSwatch.trigger('click');
        }
    } else {
        var nonPrescriptionPreviouslySelected = $('#color-variations-wrapper').find('.swatch[data-non-prescription-selected="true"]');
        if (!nonPrescriptionPreviouslySelected.length) {
            nonPrescriptionPreviouslySelected = $('#color-variations-wrapper').find('.swatch:visible').first();
        }
        nonPrescriptionPreviouslySelected.attr('data-non-prescription-selected', false);
        if (nonPrescriptionPreviouslySelected.hasClass('selected')) {
            switchPrescriptionCTAs(isFilterPrescriptionActive);
        }
        nonPrescriptionPreviouslySelected.trigger('click');
    }
}

/**
 * switch prescription ctas
 * @param {boolean} isFilterPrescriptionActive - true / false
 */
function switchPrescriptionCTAs(isFilterPrescriptionActive) {
    if (isFilterPrescriptionActive) {
        $('.rx-url[data-has-rx-url="true"], .prices-add-to-cart-actions').addClass('d-none');
        $('.rx-add-to-cart').removeClass('d-none');
        $('.js-pdp-reinsurance-asset').addClass('d-none');
        $('.js-pdp-reinsurance-asset-rxb2c').removeClass('d-none');
    } else {
        $('.rx-url[data-has-rx-url="true"], .prices-add-to-cart-actions').removeClass('d-none');
        $('.rx-add-to-cart').addClass('d-none');
        $('.js-pdp-reinsurance-asset').removeClass('d-none');
        $('.js-pdp-reinsurance-asset-rxb2c').addClass('d-none');
    }
}

module.exports = function () {
    $('.rx-prescription-filter').each(function () {
        handlePrescriptionFilter($(this));
    });
    $('.rx-prescription-filter').on('click', function (e) {
        var $target = $(e.target);
        if ($target.hasClass('toggle-text')) {
            return;
        }
        e.stopPropagation();

        /** START: data layer */
        var isFilterPrescriptionActive = $('.toggle-switch', $(this)).prop('checked');
        dataLayer.push({
            choixPrescription: isFilterPrescriptionActive ? 'Prescription' : 'Non prescription', // Prescription ou Non prescription
            event: 'OptionPrescription'
        });
        /** END: data layer */

        handlePrescriptionFilter($(this));
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        var isFilterPrescriptionActive = $('.rx-prescription-filter .toggle-switch').prop('checked');
        switchPrescriptionCTAs(response.data.product.RXFrame && isFilterPrescriptionActive);
    });

    $('.js-rxb2c-url-link').on('click', function () {
        /** START: data layer */
        dataLayer.push({
            event: 'Etape0'
        });
        /** END: data layer */
    });
};
